import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from 'react-bootstrap-v5';

export default function Hobbies({ nextStep, prevStep, maxSteps, step }) {
  const [hobbies, setHobbies] = useState([]);
  const [selectedHobbies, setSelectedHobbies] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchHobbies = async () => {
      try {
        const token = localStorage.getItem('token');
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/hobbies`, { headers });
        setHobbies(response.data);
      } catch (err) {
        setError('Error loading hobbies');
        console.error('Error fetching hobbies:', err);
      }
    };

    fetchHobbies();
  }, []);

  const toggleHobby = (hobbyId) => {
    setSelectedHobbies(prev => {
      if (prev.includes(hobbyId)) {
        return prev.filter(id => id !== hobbyId);
      } else {
        return [...prev, hobbyId];
      }
    });
  };

  return (
    <div className='container mt-5'>
      <h3>Select Your Hobbies</h3>
      {error && <div className="alert alert-danger">{error}</div>}
      
      <div className='hobbies-grid mb-4'>
        <style>
          {`
            .hobbies-grid {
              display: grid;
              grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
              gap: 10px;
              margin: 20px 0;
            }
            .hobby-button {
              width: 100%;
              margin: 5px;
            }
          `}
        </style>
        
        {hobbies.map((hobby) => (
          <Button
            key={hobby.id}
            variant={selectedHobbies.includes(hobby.id) ? 'primary' : 'outline-primary'}
            className="hobby-button"
            onClick={() => toggleHobby(hobby.id)}
          >
            {hobby.hobby_name}
          </Button>
        ))}
      </div>

      <div className='footer'>
        <button className='navigate' disabled={step === 0} onClick={prevStep}>
          Prev
        </button>
        <button
          className='navigate'
          disabled={step === maxSteps}
          onClick={nextStep}
        >
          Next
        </button>
      </div>
    </div>
  );
}
